module.exports = __webpack_public_path__ + "img/body-coordination.77b1d9c.svg";